import React, { useEffect, useState } from 'react'
import "./ItemScheduleEmail.css"
import UserImage from '../../UIcomponents/UserImage/UserImage'
import { getMinimalUserInfoData, UserInfoCache, UserInfoCacheType } from '../../../utils/staticVariables/staticVariables'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { ScheduleEmail } from '../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice'

type ItemScheduleEmailProps = {
    item: ScheduleEmail
    onDelete: (id: string) => void
    onSave: () => void
    onPress: (id: string) => void
}

const ItemScheduleEmail = ({ item, onDelete, onSave, onPress }: ItemScheduleEmailProps) => {
    
    const { t } = useTranslation()
    const [userName, setUserName] = useState("")

    useEffect(() => {
      
        const getData = () => {
            const user = UserInfoCache.userNameCache.get(item.userId)
            if(user?.name){
                setUserName(user.name)
            }else{
                getMinimalUserInfoData(item.userId)
                .then((userInfo: UserInfoCacheType) => {
                    setUserName(userInfo.name)
                })
            }
        } 

        getData()
        
    }, [])
    

    return (
        <div onClick={() => onPress(item.id)} className="width-100 card-item-schedule-notif flex mt-10 pointer">
            <div className="column-schedule-notif column-1-schedule-notif">
                <p className="fs-12 fw-700">{item.id.slice(0,4)}</p>
            </div>

            <div className="column-schedule-notif column-2-schedule-notif flex flex-ai-center">
                <UserImage userId={item.userId} sizeImg={3.8} unit={"rem"} />
                <p className="fs-12 ml-8 fw-700">{userName}</p>
            </div>

            <div className="column-schedule-notif column-3-schedule-notif">
                <p className="fs-12 fw-700">{item.subject}</p>
            </div>

            <div className="column-schedule-notif column-4-schedule-notif">
                <p className="fs-12 frecuency-square center fw-700">{t(`Notifications:schedule:frecuency:${item.frecuency}`)}</p>
            </div>

            <div className="column-schedule-notif column-5-schedule-notif">
                <p className="fs-14">{moment(item.creationDate).fromNow()}</p>
            </div>

            <div className="column-schedule-notif column-6-schedule-notif">
                <p className="fs-14">{t(`Notifications:schedule:topic:${item.topic}`)}</p>
            </div>

            <div className="column-schedule-notif column-7-schedule-notif">
                <p className="fs-14">{t(`Notifications:schedule:device:${item.device}`)}</p>
            </div>

        </div>
    )
}

export default React.memo( ItemScheduleEmail )